export const LOGIN_START = 'auth/LOGIN_START'
export const LOGIN_FAIL = 'auth/LOGIN_FAIL'
export const LOGIN_SUCCESS = 'auth/LOGIN_SUCCESS'

export const LOGOUT = 'auth/LOGOUT'
export const INIT = 'auth/INIT'
